import { useState } from "react";
// import { ButtonRounded } from "../..";
import styles from "./AppCrashedContent.module.scss";
import { displayErrorFn } from "../../../../features/src/ErrorBoundary/utils/displayError.tool";

export interface AppCrashedContentProps {
    componentStack: string
    error: any
    resetError: () => void
    codeError: string | number
}

export function AppCrashedContent(props: AppCrashedContentProps): JSX.Element {
    const { componentStack, error, resetError, codeError } = props;

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const displayError = displayErrorFn();

    if (error.toString().includes("Failed to fetch dynamically imported module")) {
        window.location.reload();
    }

    return (
        <>
            <div className={styles["AppCrashed"]}>
                <h6>
                    Une erreur inattendue a eu lieu ici
                </h6>

                <p>
                    Nous sommes sincèrement désolés mais l'application vient de rencontrer une erreur ici.
                    Vous pouvez essayer d'effacer l'erreur automatiquement en réinitialisant.
                    Si cela ne résout rien, veuillez contacter le support.
                </p>

                <div className={styles["line"]}>
                    <button size="small" onClick={() => resetError()}>
                        Reinitialiser
                    </button>

                    {displayError &&
                        <p className={styles["detail"]} onClick={() => setModalIsOpen(!modalIsOpen)}>details</p>
                    }
                    <p>Code erreur : {codeError}</p>
                </div>

            </div>

            {displayError && modalIsOpen && (
                <div isOpen={modalIsOpen} toggle={() => setModalIsOpen(false)} className={styles["AppCrashed"]}>
                    <div className={styles["card"]}>
                        <div className={styles["error"]}>
                            <h3>Erreur rencontrée : </h3>
                            <p>{error.toString()}</p>
                            <p>Code erreur : {codeError}</p>
                            <h3>StackTrace</h3>
                            <p className={styles["stackTrace"]}>
                                {componentStack}
                            </p>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}




